import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { useEffect, useRef, useState } from "react";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import MainHeading from "../../../components/comman/MainHeading";
import FilterComponent from "../../../components/comman/FilterComponent";
import CommonTable from "../../../components/comman/CommonTable";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import ViewIcon from "../../../components/Icons/ViewIcon";
import moment from "moment";

export default function TransferRequests() {
    const navigate = useNavigate();
    const timeoutId = useRef(null);
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);
    const [selectedId, setSelectedId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [pageStates, setPageStates] = useState({
        currentPage: 1,
        pageSize: 10,
        count: 0,
        totalPages: 0,
        tableLoader: false,
        TransferRequestsData: [],
        searchQuery: "",
        status: "",
    });

    useEffect(() => {
        GetRequestsList(pageStates?.currentPage);
    }, [
        pageStates?.currentPage,
        pageStates?.searchQuery,
        pageStates?.pageSize,
        pageStates?.status,
    ]);

    const GetRequestsList = () => {
        let options = {
            method: "GET",
        };
        let API = apiUrl.get_transfer_requests + "?" + MainFilterHandler({ ...pageStates });
        setPageStates((prev) => ({
            ...prev,
            tableLoader: true,
            TransferRequestsData: {},
        }));
        callApi(API, options).then((response) => {
            setPageStates((prev) => ({
                ...prev,
                tableLoader: false,
            }));
            if (response?.status === true) {
                const newData = response?.data?.transferRequest?.map((item) => ({
                    ...item,
                    name: item?.user?.name,
                    employeeCode: item?.user?.employeeCode,
                    requestedDateTime: moment(item?.createdAt).format("DD-MM-YYYY hh:mm A"),
                    from: item?.fromSite,
                    to: item?.toSite,
                    transferRequestStatus: item?.status
                }));
                setPageStates((prevStates) => ({
                    ...prevStates,
                    TransferRequestsData: newData,
                    count: response?.data?.pageInfo?.total,
                    totalPages: response?.data?.pageInfo?.totalPages,
                }));
            }
        });
    };

    const PageChangeHandler = (PageNo) => {
        if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
            setPageStates((prev) => ({
                ...prev,
                currentPage: PageNo,
            }));
        }
    };

    const handleChangePageSize = (value) => {
        setPageStates((prev) => ({
            ...prev,
            pageSize: value,
            currentPage: 1,
        }));
    };

    const handleSearchChange = (e) => {
        const { value } = e.target;
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
        }
        timeoutId.current = setTimeout(() => {
            setPageStates((prevState) => ({
                ...prevState,
                searchQuery: value,
            }));
        }, 500);
    };

    const ActionHandler = (data) => {
        setSelectedId(data?.id);
        toggle();
    };
    const HandleView = (data) => {
        navigate(RoutesLink.employee_detail + `/${data?.user?.id}`);
    };

    const HandleDelete = () => {
        let options = {
            method: "GET",
        };
        let API = apiUrl.delete_transfer_request + `?transferRequestId=${selectedId}`;
        setIsLoading(true);
        callApi(API, options).then((response) => {
            setIsLoading(false);
            if (response?.status === true) {
                toast.success(response?.message);
                toggle();
                GetRequestsList(pageStates?.currentPage);
            } else {
                toast.error(response?.message);
                toggle();
            }
        });
    };

    const TableHeading = [
        { value: "name", label: "Name" },
        { value: "employeeCode", label: "Employee Code" },
        { value: "requestedDateTime", label: "Request Date" },
        { value: "from", label: "From" },
        { value: "to", label: "To" },
        { value: "transferRequestStatus", label: "Status" },
    ];

    const ActionData = [
        {
            label: "view",
            className: "btn btn-link",
            icon: <ViewIcon />,
            title: "edit",
            clickHandler: HandleView,
        },
        {
            label: "Delete",
            className: "btn btn-link",
            icon: <DeleteIcon />,
            title: "delete",
            isShow: "pending",
            isSiteEditable: false,
            clickHandler: ActionHandler,
        },
    ];

    return (
        <>
            <div className="content">
                <MainHeading
                    title={"Transfer Requests"}
                />
                <div className="card mb-4">
                    <div className="alert alert-info text-center py-1 mb-0 py-0">
                        <small className="fs-5">
                            <strong>Note:</strong> All user transfer requests will be processed on the
                            1st day of the month following the requested transfer date.
                        </small>
                    </div>
                    <div className="card-body">
                        <FilterComponent
                            handleSearch={handleSearchChange}
                            pageStates={pageStates}
                            orderByStatus={(e) => {
                                setPageStates((prev) => ({
                                    ...prev,
                                    status: e.target.value,
                                    currentPage: 1,
                                }));
                            }}
                            orderByStatusList={[
                                { value: "", name: "All" },
                                { value: "pending", name: "Pending" },
                                { value: "completed", name: "Completed" },
                                { value: "failed", name: "Failed" },
                            ]}
                        />
                        <CommonTable
                            TableHeading={TableHeading}
                            TableData={pageStates?.TransferRequestsData}
                            ActionData={ActionData}
                            currentPage={pageStates?.currentPage}
                            PageChangeHandler={PageChangeHandler}
                            isLoading={pageStates?.tableLoader}
                            totalPages={pageStates?.totalPages}
                            count={pageStates?.count}
                            handleChangePageSize={handleChangePageSize}
                            pageSize={pageStates?.pageSize}
                        />
                    </div>
                </div>
            </div>
            <ConfirmModal
                modal={modal}
                toggle={toggle}
                submitHandler={HandleDelete}
                isLoading={isLoading}
            />
        </>
    );
}
